module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.show) ? _c('div', {
    staticClass: "pagination"
  }, [_c('button', {
    staticClass: "page",
    attrs: {
      "type": "button",
      "disabled": _vm.current === 1
    },
    on: {
      "click": function($event) {
        _vm.go(1)
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _vm._l((_vm.pages), function(n) {
    return _c('button', {
      key: n,
      staticClass: "page",
      class: {
        'current': _vm.current === n
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.go(n)
        }
      }
    }, [_vm._v(_vm._s(n))])
  }), _vm._v(" "), _c('button', {
    staticClass: "page",
    attrs: {
      "type": "button",
      "disabled": _vm.current === _vm.totalPages
    },
    on: {
      "click": function($event) {
        _vm.go(_vm.totalPages)
      }
    }
  }, [_vm._v("尾页")])], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03138791","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/pagination.vue
// module id = 462
// module chunks = 1